
let userData = null;
let testId = null;
let analysisData = null;
let studentResponses = null;
let answerKeys = null;

// Initialize on page load
document.addEventListener('DOMContentLoaded', async () => {
    try {
        console.log('🚀 ACT Analysis page loading...');
        
        // Check authentication
        userData = getUserSession();
        if (!userData) {
            window.location.href = '/page/act-login';
            return;
        }

        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        testId = urlParams.get('testId');
        const viewType = urlParams.get('view');

        console.log('📋 Test ID:', testId, '| View:', viewType);

        // Load appropriate analysis
        if (viewType === 'overall') {
            await loadOverallAnalysis();
        } else {
            if (!testId) {
                alert('No test specified');
                window.location.href = '/pages/act-dashboard';
                return;
            }
            await loadPerTestAnalysis();
        }

    } catch (error) {
        console.error('❌ Error initializing:', error);
        hideLoading();
        alert('Error loading analysis: ' + error.message);
        setTimeout(() => window.location.href = '/pages/act-dashboard', 2000);
    }
});

// Load per-test analysis
async function loadPerTestAnalysis() {
    showLoading();

    try {
        console.log('📊 Loading analysis for test:', testId);

        // STEP 1: Load student responses (includes scores)
        const responsesResponse = await SheetsAPI.getStudentResponses({
            uid: userData.uid,
            test_id: testId
        });

        console.log('📦 Student Responses:', responsesResponse);

        if (!responsesResponse || !responsesResponse.success || !responsesResponse.data) {
            throw new Error('No test data found. Please submit the test first.');
        }

        const studentData = responsesResponse.data;

        // Store student responses globally for answer review
        studentResponses = studentData;

        // Check if submitted
        if (studentData.status !== 'submitted') {
            alert('Test not submitted yet. Please complete and submit the test.');
            window.location.href = '/pages/act-dashboard';
            return;
        }

        // STEP 2: Parse scores from response
        const composite = Number(studentData.composite_score) || 0;
        const englishScore = Number(studentData.english_score) || 0;
        const mathScore = Number(studentData.math_score) || 0;
        const readingScore = Number(studentData.reading_score) || 0;

        console.log('📈 Scores:', { composite, englishScore, mathScore, readingScore });

        // STEP 3: Load answer keys for detailed analysis
        const keysResponse = await SheetsAPI.getAnswerKeys(testId);
        if (!keysResponse || !keysResponse.success) {
            throw new Error('Answer keys not found');
        }

        answerKeys = parseAnswerKeys(keysResponse.answer_keys);
        console.log('🔑 Answer keys parsed:', Object.keys(answerKeys).map(k => `${k}: ${Object.keys(answerKeys[k]).length} questions`));

        // STEP 4: Parse student answers
        const studentAnswers = {
            english: JSON.parse(studentData.english_answers || '{}'),
            math: JSON.parse(studentData.math_answers || '{}'),
            reading: JSON.parse(studentData.reading_answers || '{}')
        };

        console.log('📝 Student answers parsed:', Object.keys(studentAnswers).map(k => `${k}: ${Object.keys(studentAnswers[k]).length} answered`));

        // STEP 5: Calculate detailed analysis
        analysisData = calculateAnalysis(answerKeys, studentAnswers, {
            composite,
            englishScore,
            mathScore,
            readingScore
        });

        console.log('✅ Analysis calculated:', analysisData);

        // STEP 6: Render UI
        renderUI();

        hideLoading();

    } catch (error) {
        console.error('❌ Error in loadPerTestAnalysis:', error);
        hideLoading();
        throw error;
    }
}

// Parse answer keys from API response
function parseAnswerKeys(keys) {
    const result = {
        english: {},
        math: {},
        reading: {}
    };

    keys.forEach(row => {
        const section = String(row.section || '').toLowerCase();
        const qNum = Number(row.question_number);
        
        if ((section === 'english' || section === 'math' || section === 'reading') && qNum > 0) {
            result[section][qNum] = {
                correct_answer: String(row.correct_answer || '').trim().toUpperCase(),
                difficulty: String(row.difficulty || 'medium').toLowerCase(),
                domain: String(row.domain || 'General').trim(),
                is_scored: row.is_scored !== false && row.is_scored !== 'FALSE'
            };
        }
    });

    return result;
}

// --- 1. Place the convertToACTScale function at the top of your file ---
function convertToACTScale(correct, total) {
  if (correct === 0) return 0;
  const percentage = correct / total;

  // Mapping raw score to ACT scale (1–36)
  if (percentage >= 0.97) return 36;
  if (percentage >= 0.94) return 35;
  if (percentage >= 0.91) return 34;
  if (percentage >= 0.88) return 33;
  if (percentage >= 0.85) return 32;
  if (percentage >= 0.82) return 31;
  if (percentage >= 0.79) return 30;
  if (percentage >= 0.76) return 29;
  if (percentage >= 0.73) return 28;
  if (percentage >= 0.70) return 27;
  if (percentage >= 0.67) return 26;
  if (percentage >= 0.64) return 25;
  if (percentage >= 0.61) return 24;
  if (percentage >= 0.58) return 23;
  if (percentage >= 0.55) return 22;
  if (percentage >= 0.52) return 21;
  if (percentage >= 0.49) return 20;
  if (percentage >= 0.46) return 19;
  if (percentage >= 0.43) return 18;
  if (percentage >= 0.40) return 17;
  if (percentage >= 0.37) return 16;
  if (percentage >= 0.34) return 15;
  if (percentage >= 0.31) return 14;
  if (percentage >= 0.28) return 13;
  if (percentage >= 0.25) return 12;
  if (percentage >= 0.22) return 11;
  if (percentage >= 0.19) return 10;
  if (percentage >= 0.16) return 9;
  if (percentage >= 0.13) return 8;
  if (percentage >= 0.10) return 7;
  if (percentage >= 0.07) return 6;
  if (percentage >= 0.04) return 5;
  if (percentage >= 0.01) return 4;
  return 3;
}


function calculateAnalysis(answerKeys, studentAnswers, scores) {
    const analysis = {
        composite: scores.composite,
        total: {
            correct: 0,
            incorrect: 0,
            total: 0,
            accuracy: 0
        },
        sections: {
            english: initSection('English', scores.englishScore),
            math: initSection('Math', scores.mathScore),
            reading: initSection('Reading', scores.readingScore)
        }
    };

    // Process each section
    ['english', 'math', 'reading'].forEach(section => {
        processSection(section, answerKeys[section], studentAnswers[section], analysis.sections[section]);
    });

    // Fallback: If section scores are missing or zero, calculate them using convertToACTScale
    ['english', 'math', 'reading'].forEach(section => {
        const sec = analysis.sections[section];
        if (!sec.score || sec.score === 0) {
            sec.score = convertToACTScale(sec.correct, sec.total);
        }
    });

    // Calculate the composite score if it's missing or zero
    if (!analysis.composite || analysis.composite === 0) {
        const e = analysis.sections.english.score || 0;
        const m = analysis.sections.math.score || 0;
        const r = analysis.sections.reading.score || 0;
        analysis.composite = Math.round((e + m + r) / 3);  // Average of the section scores
    }

    // Calculate totals (SCORED ONLY for overall stats)
    analysis.total.correct = analysis.sections.english.correct + 
                            analysis.sections.math.correct + 
                            analysis.sections.reading.correct;
    
    analysis.total.incorrect = analysis.sections.english.incorrect + 
                              analysis.sections.math.incorrect + 
                              analysis.sections.reading.incorrect;
    
    analysis.total.total = analysis.total.correct + analysis.total.incorrect;
    
    analysis.total.accuracy = analysis.total.total > 0 
        ? Math.round((analysis.total.correct / analysis.total.total) * 100) 
        : 0;

    return analysis;
}

// Initialize section data structure
// UPDATED: Now tracks both scored-only and all questions (scored + unscored)
function initSection(name, score) {
    return {
        name,
        score,
        // Scored questions only (for section performance cards and score calculation)
        correct: 0,
        incorrect: 0,
        total: 0,
        accuracy: 0,
        // All questions including unscored (for gauges and difficulty charts)
        correct_all: 0,
        incorrect_all: 0,
        total_all: 0,
        accuracy_all: 0,
        difficulty: {
            easy: { correct: 0, incorrect: 0, total: 0 },
            medium: { correct: 0, incorrect: 0, total: 0 },
            hard: { correct: 0, incorrect: 0, total: 0 }
        },
        // Difficulty tracking for ALL questions (scored + unscored)
        difficulty_all: {
            easy: { correct: 0, incorrect: 0, total: 0 },
            medium: { correct: 0, incorrect: 0, total: 0 },
            hard: { correct: 0, incorrect: 0, total: 0 }
        },
        domains: {}
    };
}

// Process a single section
// UPDATED: Now tracks both scored and all questions
function processSection(sectionName, keys, answers, sectionData) {
    Object.keys(keys).forEach(qNum => {
        const keyData = keys[qNum];
        const studentAns = answers[qNum];
        const isCorrect = studentAns && studentAns === keyData.correct_answer;
        const status = studentAns ? (isCorrect ? 'correct' : 'incorrect') : 'unanswered';
        
        // ===== TRACK ALL QUESTIONS (SCORED + UNSCORED) =====
        // This is for gauges and difficulty charts
        sectionData.total_all++;
        
        if (isCorrect) {
            sectionData.correct_all++;
        } else {
            sectionData.incorrect_all++;
        }

        // Track difficulty for ALL questions
        const diff = keyData.difficulty;
        if (sectionData.difficulty_all[diff]) {
            sectionData.difficulty_all[diff].total++;
            if (isCorrect) {
                sectionData.difficulty_all[diff].correct++;
            } else {
                sectionData.difficulty_all[diff].incorrect++;
            }
        }
        
        // ===== TRACK SCORED QUESTIONS ONLY =====
        // This is for section performance cards and score calculation
        if (!keyData.is_scored) return; // Skip unscored for the rest

        sectionData.total++;
        
        if (isCorrect) {
            sectionData.correct++;
        } else {
            sectionData.incorrect++;
        }

        // Track difficulty for SCORED questions only
        if (sectionData.difficulty[diff]) {
            sectionData.difficulty[diff].total++;
            if (isCorrect) {
                sectionData.difficulty[diff].correct++;
            } else {
                sectionData.difficulty[diff].incorrect++;
            }
        }

        // Track domain (SCORED only)
        const domain = keyData.domain;
        if (!sectionData.domains[domain]) {
            sectionData.domains[domain] = {
                correct: 0,
                incorrect: 0,
                total: 0,
                questions: []
            };
        }
        sectionData.domains[domain].total++;
        sectionData.domains[domain].questions.push({ qNum, status });
        
        if (isCorrect) {
            sectionData.domains[domain].correct++;
        } else {
            sectionData.domains[domain].incorrect++;
        }
    });

    // Calculate section accuracy for SCORED questions
    sectionData.accuracy = sectionData.total > 0 
        ? Math.round((sectionData.correct / sectionData.total) * 100) 
        : 0;
    
    // Calculate section accuracy for ALL questions
    sectionData.accuracy_all = sectionData.total_all > 0 
        ? Math.round((sectionData.correct_all / sectionData.total_all) * 100) 
        : 0;
}

// ✨ NEW: Get 7-box colors based on percentage
function getBoxColors(percentage) {
    if (percentage === undefined || percentage === null || isNaN(percentage) || percentage === 0) {
        return ["lightgray", "lightgray", "lightgray", "lightgray", "lightgray", "lightgray", "lightgray"];
    } else if (percentage <= 15) {
        return ["red", "gray", "gray", "gray", "gray", "gray", "gray"];
    } else if (percentage <= 30) {
        return ["red", "red", "gray", "gray", "gray", "gray", "gray"];
    } else if (percentage <= 45) {
        return ["yellow", "yellow", "yellow", "gray", "gray", "gray", "gray"];
    } else if (percentage <= 65) {
        return ["yellow", "yellow", "yellow", "yellow", "gray", "gray", "gray"];
    } else if (percentage <= 80) {
        return ["yellow", "yellow", "yellow", "yellow", "yellow", "gray", "gray"];
    } else if (percentage <= 90) {
        return ["green", "green", "green", "green", "green", "green", "gray"];
    } else {
        return ["green", "green", "green", "green", "green", "green", "green"];
    }
}

// Render complete UI
// UPDATED: Uses _all versions for gauges and difficulty charts
function renderUI() {
    const data = analysisData;

    // Update page title to show "TEST #X Score Report"
    const titleEl = document.getElementById('pageTitle');
    if (titleEl && testId) {
        // Extract test number from testId (e.g., "test_1" -> "1")
        const testNumber = testId.replace(/\D/g, '') || testId;
        titleEl.textContent = `TEST #${testNumber} Score Report`;
    }

    // Update composite score card
    document.getElementById('compositeScore').textContent = data.composite;
    document.getElementById('correctCount').textContent = data.total.correct;
    document.getElementById('incorrectCount').textContent = data.total.incorrect;
    document.getElementById('accuracyPercent').textContent = data.total.accuracy + '%';

    // Render section cards (UNCHANGED - uses scored data)
    const sectionsGrid = document.getElementById('sectionsGrid');
    sectionsGrid.innerHTML = '';

    ['english', 'math', 'reading'].forEach(sectionKey => {
        const section = data.sections[sectionKey];
        const sectionCard = createSectionCard(section);
        sectionsGrid.appendChild(sectionCard);
    });

    // Render gauge charts (UPDATED - uses _all data to include unscored)
    createGaugeChart('englishGauge', data.sections.english.correct_all, data.sections.english.total_all);
    createGaugeChart('mathGauge', data.sections.math.correct_all, data.sections.math.total_all);
    createGaugeChart('readingGauge', data.sections.reading.correct_all, data.sections.reading.total_all);

    // Render difficulty sections (UPDATED - uses difficulty_all to include unscored)
    const difficultySections = document.getElementById('difficultySections');
    difficultySections.innerHTML = '';

    ['english', 'math', 'reading'].forEach(sectionKey => {
        const section = data.sections[sectionKey];
        const difficultySection = createDifficultySection(section, sectionKey);
        difficultySections.appendChild(difficultySection);
    });

    // Render answer review
    displayAnswerReview();

    // Set up section tab listeners
    setupSectionTabs();
}


// Create section performance card with Domain/Performance layout (7 boxes per domain)
// UNCHANGED - uses scored data
function createSectionCard(section) {
    const card = document.createElement('div');
    card.className = 'section-card';

    // Build the main section HTML (score + metrics)
    const baseHTML = `
        <div class="section-header">${section.name}</div>
        <div class="section-content">
            <div class="section-score-column">
                <div class="section-score-label">Section Score</div>
                <div class="section-score-big">${section.score}</div>
                <div class="section-score-range"> Out of 36</div>
            </div>
            <div class="section-metrics">
                <div class="metric-row correct-row">
                    <span class="metric-label">CORRECT</span>
                    <span class="metric-value correct">${section.correct}/${section.total}</span>
                </div>
                <div class="metric-row incorrect-row">
                    <span class="metric-label">INCORRECT</span>
                    <span class="metric-value incorrect">${section.incorrect}/${section.total}</span>
                </div>
                <div class="metric-row accuracy-row">
                    <span class="metric-label">ANSWERS ACCURACY</span>
                    <span class="metric-value accuracy">${section.accuracy}%</span>
                </div>
            </div>
        </div>
    `;

    // If there are domains, build a tidy row-per-domain layout so name + boxes align
    let domainSectionHTML = '';
    const domainNames = Object.keys(section.domains || {});

    if (domainNames.length > 0) {
        const rowsHTML = domainNames.map(domainName => {
            const domainData = section.domains[domainName];
            const correct = domainData.correct || 0;
            const total = domainData.total || 0;
            const percentage = total > 0 ? (correct / total) * 100 : 0;

            // Get 7 box colors and render them (maps 'green'/'red' -> .correct, else -> .incorrect)
            const colors = getBoxColors(percentage);
                const boxesHTML = colors.map(color => {
                return `<div class="domain-box ${color}" title="${correct} of ${total} correct (${percentage.toFixed(0)}%)"></div>`;
               }).join('');

            // Single line: domain name on left, boxes on right
            return `
                <div class="domain-row">
                    <div class="domain-name">
                        ${domainName}
                        <span class="count">(${total} questions total)</span>
                    </div>
                    <div class="domain-boxes">
                        ${boxesHTML}
                    </div>
                </div>
            `;
        }).join('');

        domainSectionHTML = `
            <div class="domain-section">
                <div class="domain-header-row">
                    <div class="domain-title">Domain</div>
                    <div class="performance-title">Performance</div>
                </div>
                <div class="domain-content-row">
                    ${rowsHTML}
                </div>
            </div>
        `;
    }

    card.innerHTML = baseHTML + domainSectionHTML;
    return card;
}

// Create gauge chart
// UNCHANGED - just displays the data passed to it
function createGaugeChart(canvasId, correct, total) {
    const ctx = document.getElementById(canvasId);
    if (!ctx) {
        console.error('Canvas not found:', canvasId);
        return;
    }

    const hasData = total > 0;
    const percentage = hasData ? (correct / total) * 100 : 0;

    new Chart(ctx, {
        type: 'doughnut',
        data: {
            datasets: [{
                data: hasData ? [correct, total - correct] : [1],
                backgroundColor: hasData ? ['#1857f1', '#e5e7eb'] : ['#e5e7eb'],
                borderWidth: 0,
                circumference: 270,
                rotation: 225
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: true,
            cutout: '75%',
            plugins: {
                legend: { display: false },
                tooltip: { enabled: false }
            }
        },
        plugins: [{
            id: 'centerText',
            afterDraw: (chart) => {
                if (!hasData) return;

                const ctx = chart.ctx;
                const centerX = chart.width / 2;
                const centerY = chart.chartArea.top + chart.chartArea.height / 2;

                ctx.save();
                ctx.font = 'bold 32px Segoe UI, sans-serif';
                ctx.fillStyle = '#1e293b';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(correct, centerX, centerY - 12);
                ctx.font = '14px Segoe UI, sans-serif';
                ctx.fillStyle = '#666';
                ctx.fillText('correct', centerX, centerY + 20);
                ctx.restore();
            }
        }, {
             id: 'edgeLabels',
            afterDatasetsDraw: (chart) => {
                const ctx = chart.ctx;
                const centerX = chart.width / 2;
                const centerY = chart.chartArea.top + chart.chartArea.height / 2;
                const metaData = chart._metasets[0].data[0];
                const radius = metaData.outerRadius;

                ctx.save();
                ctx.font = 'bold 14px Segoe UI, sans-serif';
                ctx.fillStyle = '#444';
                ctx.textBaseline = 'top';

                // Left label (0) at -135° - position below the arc endpoint
                const startAngle = (135 * Math.PI) / 180;
                const leftX = centerX + radius * Math.cos(startAngle);
                const leftY = centerY + radius * Math.sin(startAngle);
                ctx.textAlign = 'left';
                ctx.fillText('0', leftX - 20 , leftY + 10);

                // Right label (total) at +135° - position below the arc endpoint
                const endAngle = (41 * Math.PI) / 180;
                const rightX = centerX + radius * Math.cos(endAngle);
                const rightY = centerY + radius * Math.sin(endAngle);
                ctx.textAlign = 'right';
                ctx.fillText(total.toString(), rightX + 20, rightY + 22);

                ctx.restore();
                    }
        }]
    });
}

// UPDATED: Now uses difficulty_all to include unscored questions
function createDifficultySection(section, sectionKey) {
    const container = document.createElement('div');
    container.className = 'difficulty-section';

    const chartsHTML = ['easy', 'medium', 'hard'].map(diff => {
        const data = section.difficulty_all[diff]; 
        const canvasId = `${sectionKey}-${diff}-chart`;
        
        return `
            <div class="difficulty-item">
                <div class="difficulty-label">${diff.charAt(0).toUpperCase() + diff.slice(1)}</div>
                <div class="difficulty-chart">
                    <canvas id="${canvasId}"></canvas>
                </div>
            </div>
        `;
    }).join('');

    container.innerHTML = `
        <div class="difficulty-section-title">${section.name}</div>
        <div class="difficulty-charts">${chartsHTML}</div>
    `;

    // Render charts after DOM insertion
    setTimeout(() => {
        ['easy', 'medium', 'hard'].forEach(diff => {
            const canvasId = `${sectionKey}-${diff}-chart`;
            createDonutChart(canvasId, section.difficulty_all[diff]); // UPDATED: Using difficulty_all
        });
    }, 100);

    return container;
}

// Create donut chart with thinner thickness
// UNCHANGED - just displays the data passed to it
function createDonutChart(canvasId, data) {
    const ctx = document.getElementById(canvasId);
    if (!ctx) {
        console.error('Canvas not found:', canvasId);
        return;
    }

    const total = data.correct + data.incorrect;
    const hasData = total > 0;

    new Chart(ctx, {
        type: 'doughnut',
        data: {
            datasets: [{
                data: hasData ? [data.correct, data.incorrect] : [1],
                backgroundColor: hasData ? ['#1857f1', '#e5e7eb'] : ['#e5e7eb'],
                borderWidth: 0
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: true,
            cutout: '80%', /* Changed from 70% to 80% for thinner donuts */
            plugins: {
                legend: { display: false },
                tooltip: { enabled: false }
            }
        },
        plugins: [{
            id: 'donutText',
            afterDraw: (chart) => {
                if (!hasData) return;

                const ctx = chart.ctx;
                const centerX = chart.width / 2;
                const centerY = chart.height / 2;
                
                ctx.save();
                ctx.font = 'bold 18px sans-serif';
                ctx.fillStyle = '#1e293b';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(`${data.correct} correct`, centerX, centerY - 8);
                
                ctx.font = '14px sans-serif';
                ctx.fillStyle = '#64748b';
                ctx.fillText(`${data.incorrect} incorrect`, centerX, centerY + 12);
                ctx.restore();
            }
        }]
    });
}

// When populating the sections, ensure the order is: English, Math, Reading
// Modify your population code like this:
function populateDifficultySections(data) {
    const container = document.getElementById('difficultySections');
    
    // Define the order: English, Math, Reading
    const sectionOrder = ['english', 'math', 'reading'];
    
    sectionOrder.forEach(key => {
        if (data.sections[key]) {
            const section = createDifficultySection(data.sections[key], key);
            container.appendChild(section);
        }
    });
}

// Load overall analysis (all tests)
async function loadOverallAnalysis() {
    showLoading();

    try {
        console.log('📊 Loading overall analysis');

        const historyResponse = await SheetsAPI.getStudentTestHistory({ uid: userData.uid });
        
        if (!historyResponse || !historyResponse.success) {
            throw new Error('No test history found');
        }

        const tests = historyResponse.data || [];
        const submittedTests = tests.filter(t => t.status === 'submitted');

        console.log(`Found ${submittedTests.length} submitted tests`);

        if (submittedTests.length === 0) {
            document.getElementById('pageTitle').textContent = 'Overall Analysis';
            document.getElementById('compositeScore').textContent = 'No tests completed';
            hideLoading();
            return;
        }

        // Calculate averages
        let totalComposite = 0;
        let totalEnglish = 0;
        let totalMath = 0;
        let totalReading = 0;

        for (const test of submittedTests) {
            const resp = await SheetsAPI.getStudentResponses({
                uid: userData.uid,
                test_id: test.test_id
            });

            if (resp && resp.success && resp.data) {
                totalComposite += Number(resp.data.composite_score) || 0;
                totalEnglish += Number(resp.data.english_score) || 0;
                totalMath += Number(resp.data.math_score) || 0;
                totalReading += Number(resp.data.reading_score) || 0;
            }
        }

        const count = submittedTests.length;
        
        document.getElementById('pageTitle').textContent = `Overall Analysis (${count} tests)`;
        document.getElementById('compositeScore').textContent = Math.round(totalComposite / count);
        
        // Hide sections grid for overall view
        document.getElementById('sectionsGrid').innerHTML = `
            <div style="grid-column: 1/-1; text-align: center; padding: 2rem;">
                <h3>Average Scores Across ${count} Tests</h3>
                <p>English: ${Math.round(totalEnglish / count)} | Math: ${Math.round(totalMath / count)} | Reading: ${Math.round(totalReading / count)}</p>
            </div>
        `;

        hideLoading();

    } catch (error) {
        console.error('❌ Error in loadOverallAnalysis:', error);
        hideLoading();
        throw error;
    }
}

// Display answer review - WITHOUT difficulty badges (removed as requested)
function displayAnswerReview() {
    const reviewContainer = document.getElementById('answerReview');
    if (!reviewContainer) return;

    // Parse student answers from the global analysisData
    const studentAnswersRaw = {
        english: JSON.parse(studentResponses?.english_answers || '{}'),
        math: JSON.parse(studentResponses?.math_answers || '{}'),
        reading: JSON.parse(studentResponses?.reading_answers || '{}')
    };

    // We need to get student responses from the API data
    // This should already be available from loadPerTestAnalysis
    reviewContainer.innerHTML = '';

    ['english', 'math', 'reading'].forEach(section => {
        const reviewSection = document.createElement('div');
        reviewSection.className = 'review-section';
        reviewSection.dataset.section = section;
        reviewSection.style.display = section === 'english' ? 'block' : 'none';

        const keys = answerKeys[section];
        const answers = studentAnswersRaw[section];

        const answerGrid = document.createElement('div');
        answerGrid.className = 'answer-grid-improved';

        Object.keys(keys).sort((a, b) => Number(a) - Number(b)).forEach(qNum => {
            const keyData = keys[qNum];
            // Create item WITHOUT difficulty badge (removed as requested)
            const item = createImprovedAnswerItem(
                qNum,
                answers[qNum],
                keyData.correct_answer
            );
            answerGrid.appendChild(item);
        });

        reviewSection.appendChild(answerGrid);
        reviewContainer.appendChild(reviewSection);
    });
}

// Create improved answer item - WITHOUT difficulty badge
function createImprovedAnswerItem(questionNum, studentAnswer, correctAnswer) {
    const item = document.createElement('div');
    
    let status = 'unanswered';
    let statusClass = 'status-gray';
    let statusIcon = '○';
    let borderColor = '#d1d5db';
    
    if (studentAnswer) {
        if (studentAnswer === correctAnswer) {
            status = 'correct';
            statusClass = 'status-green';
            statusIcon = '✓';
            borderColor = '#10b981';
        } else {
            status = 'incorrect';
            statusClass = 'status-red';
            statusIcon = '✗';
            borderColor = '#ef4444';
        }
    }

    item.className = `answer-item-improved ${statusClass}`;
    item.style.borderLeftColor = borderColor;

    // NO difficulty badge shown (removed as requested)
    item.innerHTML = `
        <div class="answer-row">
            <div class="answer-left">
                <span class="q-number">${questionNum}</span>
                <span class="status-icon ${statusClass}">${statusIcon}</span>
            </div>
            <div class="answer-middle">
                ${status === 'correct' 
                    ? `<span class="student-ans correct">${studentAnswer}</span>`
                    : status === 'incorrect'
                        ? `<span class="student-ans incorrect">${studentAnswer}</span>
                           <span class="arrow">→</span>
                           <span class="correct-ans">${correctAnswer}</span>`
                        : `<span class="student-ans unanswered">—</span>
                           <span class="correct-ans-small">(${correctAnswer})</span>`
                }
            </div>
        </div>
    `;

    return item;
}

// Set up section tabs for answer review
function setupSectionTabs() {
    const tabs = document.querySelectorAll('.section-tab');
    const sections = document.querySelectorAll('.review-section');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            // Remove active class from all tabs
            tabs.forEach(t => t.classList.remove('active'));
            // Add active class to clicked tab
            tab.classList.add('active');

            // Hide all sections
            sections.forEach(s => s.style.display = 'none');
            
            // Show selected section
            const sectionName = tab.dataset.section;
            const sectionToShow = document.querySelector(`.review-section[data-section="${sectionName}"]`);
            if (sectionToShow) {
                sectionToShow.style.display = 'block';
            }
        });
    });
}

// Utility functions
function showLoading() {
    document.getElementById('loading').style.display = 'flex';
}

function hideLoading() {
    document.getElementById('loading').style.display = 'none';
}

function handleLogout() {
    if (confirm('Are you sure you want to logout?')) {
        Auth.logout();
    }
}